import src from "IMAGE";
export default { src, width: 311, height: 254, blurWidth: 0, blurHeight: 0};
